let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cteZt")).then(() => parcelRequire('1c0dW'));